export const AI_PROCESS_SCOPE_TYPE = {
  LOAN_APPLICATION: 'LoanApplication',
  CONTACT: 'Contact',
  SUB_COMPANY: 'SubCompany',
  RATE_SHEET_UPLOAD: 'RateSheetUpload',
};

export const AI_PROCESS_SCOPE_TYPE_OPTIONS = [
  { name: 'Loan Application', value: AI_PROCESS_SCOPE_TYPE.LOAN_APPLICATION },
  { name: 'Contact', value: AI_PROCESS_SCOPE_TYPE.CONTACT },
  { name: 'SubCompany', value: AI_PROCESS_SCOPE_TYPE.SUB_COMPANY },
  { name: 'Rate Sheet Upload', value: AI_PROCESS_SCOPE_TYPE.RATE_SHEET_UPLOAD },
];

export const DEFAULT_SCOPE_TYPE_OPTION = AI_PROCESS_SCOPE_TYPE_OPTIONS[0];

export const AI_PROCESS_EXECUTION_MODE = {
  SEQUENTIAL: 'Sequential',
  PARALLEL: 'Parallel',
};

export const AI_PROCESS_STEP_FAILURE_POLICY = {
  CONTINUE_INDEPENDENT_STEPS: 'ContinueIndependentSteps',
  STOP_RUN: 'StopRun',
};

export const AI_PROCESS_DEFAULT_MAX_PARALLEL_STEPS = 4;
export const AI_PROCESS_MAX_PARALLEL_STEPS_LIMIT = 8;
